/**
 * Replaces AIO Search's compact product results with the theme's real
 * card-product-wide design (Genuine badge, Check Compatibility, Add to
 * cart), fetched per-product via Shopify's section rendering API. AIO
 * Search still owns matching/relevance/pagination; this only swaps how
 * each matched product is displayed.
 *
 * AIO's index can lag Shopify's actual catalog (e.g. a product it has
 * indexed gets unpublished later), which 404s here even though AIO still
 * returned it as a match. When that happens the section renders Dawn's
 * empty-state placeholder ("Example product title") instead of throwing,
 * so success alone isn't proof of a real product — REAL_CARD_MARKER checks
 * for the card-wrapper-wide class that only the populated branch emits.
 */
(function () {
  var CARD_SECTION_ID = 'search-result-card';
  var ITEM_SELECTOR = 'a.aio-search-result-item--compact';
  var CONTENT_SECTION_SELECTOR = '.aio-search-content-section';
  var CONTENT_HEADING_SELECTOR = '.aio-search-content-heading';
  var CONTENT_HEADING_TEXT = 'Repair Guides & FAQs';
  var SHOW_MORE_SELECTOR = '.aio-search-show-more-btn';
  var REAL_CARD_MARKER = 'card-wrapper-wide';
  var MAX_CONCURRENT = 4;
  var root = document.querySelector('[data-aio-search-page-results]');
  if (!root) return;
  var sidebar = document.getElementById('HtrSearchSidebar');

  // AIO's "Pages & blog" results render inline after the product list
  // (config: section_position "after_products"). The site wants that
  // content in the sidebar instead, so move the whole block there —
  // AIO's own markup/behavior is kept as-is, just relocated.
  function moveContentSectionToSidebar() {
    if (!sidebar) return;
    var section = root.querySelector(CONTENT_SECTION_SELECTOR);
    if (!section) return;
    section.classList.add('htr-search-content-in-sidebar');
    var heading = section.querySelector(CONTENT_HEADING_SELECTOR);
    if (heading) heading.textContent = CONTENT_HEADING_TEXT;
    sidebar.insertBefore(section, sidebar.firstChild);
  }

  // AIO's "Show more" button ships with no styling of its own (bare
  // browser-default button, 90s-style outset border). Tag it so the
  // theme CSS can restyle it to match the site's real button design.
  function styleShowMoreButton() {
    var btn = root.querySelector(SHOW_MORE_SELECTOR + ':not(.htr-search-show-more)');
    if (!btn) return;
    btn.classList.add('htr-search-show-more');
  }

  function fetchCardHtml(handle) {
    return fetch('/products/' + handle + '?section_id=' + CARD_SECTION_ID)
      .then(function (res) {
        if (!res.ok) throw new Error('Card fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section =
          doc.getElementById('shopify-section-' + CARD_SECTION_ID) ||
          doc.querySelector('[id^="shopify-section-"]');
        if (!section || section.innerHTML.indexOf(REAL_CARD_MARKER) === -1) {
          // AIO matched a handle that no longer resolves to a real product.
          throw new Error('Stale AIO match: no live product at this handle');
        }
        return section.innerHTML;
      });
  }

  function productHandleFromHref(href) {
    var path;
    try {
      path = new URL(href, window.location.origin).pathname;
    } catch (e) {
      return null;
    }
    var match = path.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function enhanceOne(item) {
    // data-htr-enhanced is already set to 'pending' synchronously by
    // enhance() before this runs, so re-entrant MutationObserver firings
    // (triggered by our own DOM writes below) can't re-claim this item
    // into a second, overlapping worker pool.
    var handle = productHandleFromHref(item.getAttribute('href') || '');
    if (!handle) {
      item.setAttribute('data-htr-enhanced', 'skipped');
      return Promise.resolve();
    }

    var placeholder = document.createElement('div');
    placeholder.className = 'grid__item-wide htr-search-result-card';
    placeholder.setAttribute('data-htr-card-loading', '');
    item.insertAdjacentElement('afterend', placeholder);
    item.style.display = 'none';

    return fetchCardHtml(handle)
      .then(function (html) {
        placeholder.innerHTML = html;
        placeholder.removeAttribute('data-htr-card-loading');
        item.remove();
      })
      .catch(function () {
        // Fall back to AIO's own compact row if the card fetch fails
        // or turns out to be a stale (unpublished) product match.
        placeholder.remove();
        item.style.display = '';
        item.setAttribute('data-htr-enhanced', 'failed');
      });
  }

  function runWithConcurrencyLimit(items, limit) {
    var queue = Array.prototype.slice.call(items);

    function worker() {
      var next = queue.shift();
      if (!next) return Promise.resolve();
      return enhanceOne(next).then(worker);
    }

    var workers = [];
    for (var i = 0; i < limit; i++) workers.push(worker());
    return Promise.all(workers);
  }

  function enhance() {
    moveContentSectionToSidebar();
    styleShowMoreButton();

    var items = root.querySelectorAll(ITEM_SELECTOR + ':not([data-htr-enhanced])');
    if (!items.length) return;
    // Claim every item up front, synchronously, before any fetch/DOM work
    // starts — otherwise a mutation fired mid-enhancement re-triggers this
    // function and re-discovers not-yet-dequeued items as "unclaimed".
    items.forEach(function (item) {
      item.setAttribute('data-htr-enhanced', 'pending');
    });
    runWithConcurrencyLimit(items, MAX_CONCURRENT);
  }

  var pendingFrame = null;
  var observer = new MutationObserver(function () {
    if (pendingFrame) clearTimeout(pendingFrame);
    pendingFrame = setTimeout(enhance, 80);
  });
  observer.observe(root, { childList: true, subtree: true });

  enhance();
})();
